<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text>
            <m-autocomplete
                :type="type"
                v-model="value"
            />
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="value == null"
            >
            Add
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
import mAutocomplete from './m-autocomplete.vue';

export default {
  components: { mAutocomplete },

    props: {
        type: {
            type: String,
            default: function() { return 'bulk_message'; },
        },
    },

    data() {
        return {
            dialog: false,
            value: null,
        }
    },

    methods: {

        showDialog()
        {
            this.value = null;
            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;
            this.$emit('ok', this.value);
        },

        onCancel()
        {
            this.dialog = false;
        },
    },

    computed: {
        title() {

            if ( this.type == 'bulk_message' )
                return 'Select Bulk Message';

            return 'Select One';
        }
    },
}
</script>

<style lang="scss" scoped>
</style>